
export const headerData = {
    name: 'AbdAlrahman Alkhoja',
    title: "Hello! I am",
    desciption: "Hello! I am Abd Alrahman Alkhoja, a professional and passionate programmer in my daily life. A quick learner with a self-learning attitude. I love to learn and explore new technologies and am passionate about problem solving. ",
    image: 'https://smart-parking.tech/abd.png',
    imagebw: 'https://smart-parking.tech/abd.png',
    resumePdf: 'https://files.fm/u/ygzyryuqjn#/view/v6b9fhjara'}
